/** ヨテピースのシグネチャ：2つの輪がピタッと重なるマーク（indigo × teal）*/
export default function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <circle cx="12.5" cy="16" r="7.5" stroke="var(--color-brand)" strokeWidth="2.6" />
      <circle cx="19.5" cy="16" r="7.5" stroke="var(--color-teal)" strokeWidth="2.6" />
    </svg>
  )
}

/** ロゴ＋ワードマーク */
export function Wordmark({ size = 28 }: { size?: number }) {
  return (
    <span className="flex items-center gap-2">
      <Logo size={size} />
      <span className="text-xl font-extrabold tracking-tight text-ink">ヨテピース</span>
    </span>
  )
}
